import { twMerge } from 'tailwind-merge';

const Screw = ({ className }: { className: string }) => (
	<div
		className={twMerge(
			'absolute rounded-full w-[5px] h-[5px] bg-[#6B6B6B]',
			className
		)}
	/>
);

export default function DoubleBorderContainer({
	children,
	screws,
	className,
	innerClassName,
}: {
	children: React.ReactNode;
	screws?: boolean;
	className?: string;
	innerClassName?: string;
}) {
	return (
		<div
			className={twMerge(
				'p-[2px] border border-[#1EC4D4] rounded-[10px] bg-[#25252580]',
				className
			)}
		>
			<div
				className={twMerge(
					'w-full py-2 px-3 border border-[#F7931A] rounded-[8px] bg-[#00000050] relative',
					innerClassName
				)}
			>
				{screws && (
					<>
						<Screw className="top-[5px] left-[5px]" />
						<Screw className="top-[5px] right-[5px]" />
						<Screw className="bottom-[5px] left-[5px]" />
						<Screw className="bottom-[5px] right-[5px]" />
					</>
				)}
				{children}
			</div>
		</div>
	);
}
